import {EventBus} from "../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../common/ts/events/Events";
import {ShowRetentionCaptureModalRequestedEvent} from "../components/retention/email/main/events";
import {SerpClickSimilarAdsRequestedEvent, SerpLoadedEvent, SerpProjectsLoadedSuccessfullyEvent} from "./events";
import {SetItemEvent} from "../../../common/ts/core/localStorage";
import api from "../api";
import http from "../../../common/ts/core/http";
import dom from "../../../common/ts/core/dom";
import tracking from "../../../common/ts/core/tracking";

let eventBus: EventBus;
const PROJECT_SNIPPET_BLOCK = '#project-snippet';

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(SerpLoadedEvent.TYPE, serpLoadedEventHandler);
    eventBus.subscribe(SerpClickSimilarAdsRequestedEvent.TYPE, serpClickSimilarAdsRequestedEventHandler);
    eventBus.subscribe(SerpProjectsLoadedSuccessfullyEvent.TYPE, serpProjectsLoadedSuccessfullyHandler);
}

export function serpLoadedEventHandler(event: WhitelabelEvent) {
    const { payload: {
        search,
        shouldShowRetentionCaptureModal,
        shouldShowProjectSnippet,
        hasPreviousSuggestions,
        storedSearches,
        operationType,
        filters,
        geoEntity,
        pageviewId,
        serpUrl,
    }} = event as SerpLoadedEvent
    let shouldShowModal: boolean = shouldShowRetentionCaptureModal;
    if (hasSearchAlreadyBeenVisited(search, storedSearches)) {
        shouldShowModal = false;
    }

    if (shouldShowModal) {
        eventBus.emit(new ShowRetentionCaptureModalRequestedEvent({
            search,
            hasPreviousSuggestions,
        }))

        updateStoredSearches(search, storedSearches);

        eventBus.emit(new dom.UpdateDataAttributeEvent({
            elementSelector: "#js-email-retention-form",
            attributeName: "data-form-origin-opened-from",
            attributeValue: "desktop-auto-show",
        }));
    }

    if (shouldShowProjectSnippet) {
        const formattedSearch = search.replace(" ", "+").toLowerCase();
        eventBus.emit(
            new http.PostEvent({
                body: {
                    operationType: operationType,
                    textSearch: search,
                    filters: filters,
                    geoEntity: geoEntity,
                }, successEvent: {eventClass: SerpProjectsLoadedSuccessfullyEvent},
                url: "/api/serp-projects?search_terms="+ formattedSearch + "&page=1" + "&t_pvid=" + pageviewId
            })
        )
    }
}

function hasSearchAlreadyBeenVisited(search: string, storedSearches: string | null) {
    if (storedSearches) {
        const parsedSearches = JSON.parse(storedSearches) || [];
        return parsedSearches.includes(search);
    }

    return false;
}

function updateStoredSearches(search: string, storedSearches: string | null) {
    let searchesToSave: string[] = [];
    if (storedSearches) {
        const parsedSearches = JSON.parse(storedSearches);
        parsedSearches.push(search);
        searchesToSave = parsedSearches;
    } else {
        searchesToSave = [search];
    }

    if (searchesToSave.length > 0) {
        eventBus.emit(new SetItemEvent({ key: "visitedSearches", value: JSON.stringify(searchesToSave) }));
    }
}

type SerpClickSimilarAdsRequestParams = {
    id: string,
    q: string,
    number: number,
    ids: string,
    currentOrigin: string,
    pageViewId: string,
};

export function serpClickSimilarAdsRequestedEventHandler(event: WhitelabelEvent) {
    const { payload: {
        adId,
        search,
        ids,
        pageSectionId,
        numberOfAds,
        pageViewId,
        successEventClass,
    } } = event as SerpClickSimilarAdsRequestedEvent;

    const idsParam = ids == null ? '' : ids.join(',')

    const params = {
        id: adId,
        q: search,
        number: numberOfAds,
        currentOrigin: pageSectionId,
        pageViewId: pageViewId,
        ids: idsParam,
    } as SerpClickSimilarAdsRequestParams;

    // @ts-ignore
    Object.keys(params).forEach(key => params[key] === undefined && delete params[key])

    eventBus.emit(
        api.events.retrieveSerpClickSimilarAds(
            params,
            {
                eventClass: successEventClass,
                payload: (event as SerpClickSimilarAdsRequestedEvent).payload
            }
        )
    )
}

export function serpProjectsLoadedSuccessfullyHandler(event: WhitelabelEvent) {
    const { payload: {
        response
    } } = event as SerpProjectsLoadedSuccessfullyEvent;

    const projectSnippetBlock = dom.select(PROJECT_SNIPPET_BLOCK)
    if (!projectSnippetBlock) return
    projectSnippetBlock.innerHTML = response
}

export default {
    init,
};
